import { SheetGeometryCategory } from "building-types/views/sheetGeometryCategory";

const OverridableAnnotationSheetGeometryCategories: SheetGeometryCategory[] = [
  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_TICK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
];

const OverridableTagSheetGeometryCategories: SheetGeometryCategory[] = [
  SheetGeometryCategory.ROOM_LABELS,
  SheetGeometryCategory.SECTION_VIEW_CALLOUT,
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
];

const OverridablePropSheetGeometryCategories: SheetGeometryCategory[] = [
  SheetGeometryCategory.PROP_APPLIANCES,
  SheetGeometryCategory.PROP_FIXTURES,
  SheetGeometryCategory.PROP_FURNITURE,
  SheetGeometryCategory.PROP_OTHER,
  SheetGeometryCategory.PROP_TAG,
];

const OverridableCeilingSheetGeometryCategories: SheetGeometryCategory[] = [SheetGeometryCategory.CEILING];

export const OverridableSheetGeometryCategories: SheetGeometryCategory[] = [
  ...OverridableAnnotationSheetGeometryCategories,
  ...OverridableTagSheetGeometryCategories,
  ...OverridableCeilingSheetGeometryCategories,
  ...OverridablePropSheetGeometryCategories,
];

export const OverridableSheetGeometryCategoriesNoTags: SheetGeometryCategory[] = [
  ...OverridableAnnotationSheetGeometryCategories,
  ...OverridableCeilingSheetGeometryCategories,
  ...OverridablePropSheetGeometryCategories,
];

export const OverridableSheetGeometryCategoriesNoProps: SheetGeometryCategory[] = [
  ...OverridableAnnotationSheetGeometryCategories,
  ...OverridableCeilingSheetGeometryCategories,
];

export const ScaleableSheetGeometryCategories: SheetGeometryCategory[] = [
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,
  SheetGeometryCategory.ELECTRICAL_LOADS,
  // Scaling a load symbol must scale its label - implicit while the label lived in the symbol's SVG.
  // Existing SCALING effects are backfilled by migration_20260811_add_electric_load_label.
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
];

export const OverridableSheetGeometryGroupCategories: SheetGeometryCategory[] = [SheetGeometryCategory.ANNOT_DIM_GROUP];

export function isOverridableSheetGeometryCategory(category: SheetGeometryCategory): boolean {
  return OverridableSheetGeometryCategories.includes(category);
}

export function isScaleableSheetGeometryCategory(category: SheetGeometryCategory): boolean {
  return ScaleableSheetGeometryCategories.includes(category);
}
